import { useEffect } from 'react';
import styled from 'styled-components';

import RichText from 'components/RichText';

import useInView from 'hooks/useInView';

import COLORS from 'styles/colors';
import { rem, weight } from 'styles/typography';

import { isClient } from 'utils/helpers';

const Banner = styled.div`
  position: absolute;
  top: 0;
  display: block;
  width: 100%;
  background-color: var(--bg-color);
  color: ${COLORS.white};
  z-index: 40;
  text-decoration: var(--text-decoration);
  cursor: var(--cursor);

  p {
    margin: 0;
    opacity: 1;
  }
`;

const Copy = styled(RichText)`
  > * {
    padding: 18px;
    font-size: ${rem(14)};
    line-height: ${rem(14)};
    font-weight: ${weight.semibold};
    text-align: center;
  }
`;

const BannerCTA = ({ bannerCopy, scrollToSectionId, bgColor = 'forest' }) => {
  const [inViewRef, inView] = useInView(false);

  useEffect(() => {
    if (!isClient()) return null;

    const root = window.document.documentElement;

    root.style.setProperty(
      '--landing-has-banner',
      inView ? `translate3d(0, 50px, 0)` : `translate3d(0, 0, 0)`
    );

    return () => {
      root.style.setProperty('--landing-has-banner', `translate3d(0, 0, 0)`);
    };
  }, [inView]);

  const handleScrollToSection = () => {
    const el = document.getElementById(scrollToSectionId);

    if (el) {
      const { top } = el.getBoundingClientRect();

      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const styles = {
    '--bg-color': COLORS[bgColor],
    '--text-decoration': scrollToSectionId ? 'underline' : 'none',
    '--cursor': scrollToSectionId ? 'pointer' : 'initial',
  };

  return (
    <Banner
      ref={inViewRef}
      onClick={() => {
        if (scrollToSectionId) {
          handleScrollToSection(handleScrollToSection);
        }
      }}
      style={styles}
    >
      <Copy html={bannerCopy?.html} />
    </Banner>
  );
};

export default BannerCTA;
